"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.colors = void 0;
exports.colors = {
    "blue-dark": "#02427E",
    "blue-extra-light": "#DEEFFF",
    "blue-lighter-2": "#C8E4FE",
    "blue-lightest": "#EEF7FF",
    "dark-logo-green-tint-1": "#267F4C",
    "dark-logo-green-tint-2": "#2A9859",
    green: "#008254",
    "green-dark": "#006642",
    "green-darkest": "#00482F",
    "green-extra-light": "#EFFCF8",
    "green-lighter-2": "#2A9859",
    "green-lighter": "#81D6B8",
    "green-lightest": "#E3FAF2",
    "green-tint-lp": "#A8EA4C",
    lime: "#E2FF39",
    "lime-tint-lp-1": "#DDFA88",
    "lime-tint-lp-2": "#E8FDAC",
    "orange-nw-plus": "#F8991D",
    "starbust-red": "#FF6A4D",
    "thriver-blue": "#BCEBFF",
    "thriver-blue-tint-1": "#D7F3FF",
    "wavy-pink": "#FF97E9",
    "yellow-lighter": "#FFE2AE",
    "yellow-lighter-2": "#FFF0D6",
    "yellow-lightest": "#FFF7EA",
};
